import { render, staticRenderFns } from "./GarageDoorDamageSeverity.vue?vue&type=template&id=7a9d87ae&scoped=true"
import script from "./GarageDoorDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./GarageDoorDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9d87ae",
  null
  
)

export default component.exports